import * as Constants from "utils/Constants";
import * as actionConstants from "../constants/action-types";

import authService from '../../components/api-authorization/AuthorizeService';
import axios from 'axios'
import toast from 'utils/toast';

function errorResponseHandler(error) {

}


// Request interceptor for API calls
axios.interceptors.request.use(
    async config => {

        const token = await authService.getAccessToken();
        config.headers.Authorization =  !token ? {} : `Bearer ${token}`;
   
        return config;
    },
    error => {
        return Promise.reject(error)
  });


// Add a response interceptor
axios.interceptors.response.use(function (response) {

    const suppressToast = response.config.headers['X-Suppress-Toast'] === 'true' || 
                         response.config.suppressToast === true;
    
    if (!response.config.url.toUpperCase().includes("UPLOAD") && !suppressToast) {

        const messages = response.data.Messages? response.data.Messages : response.data.messages;
        const operationSuccessful = response.data.OperationSuccessful? response.data.OperationSuccessful : response.data.operationSuccessful;
        
        if (operationSuccessful) {
            if (response.config.method !== "get") {
                if (messages.length > 0) {
                    for (let index in messages) {
                        let msg = messages[index];
                        const messageContent = msg.MessageContent ? msg.MessageContent : msg.messageContent;
                        const messageTypeId = msg.MessageTypeId ? msg.MessageTypeId : msg.messageTypeId;

                        if (messageTypeId === actionConstants.messageTypeEnum.Warning) {
                            toast.warning(messageContent);
                        }
                        else if (messageTypeId === actionConstants.messageTypeEnum.Success) {
                            toast.success(messageContent);
                        }
                    }
                } 
                else {
                    const includeKeys = [
                        "PROVIDEREXPORTVIEW",
                        "SENDVERIFYEMAIL",
                        "SENDCOMMENTNOTIFICTION",
                        "SendCommentNotifiction"
                    ];
                    const url = response.config.url.toUpperCase();
                    const matches = includeKeys.some(key => url.includes(key));
                    if(!matches){
                        toast.success("Operation Successful.");
                    }
                }
            }
        } 
        else {
            for (let index in messages) {
                let msg = messages[index];
                const messageContent = msg.MessageContent ? msg.MessageContent : msg.messageContent;
                const messageTypeId = msg.MessageTypeId ? msg.MessageTypeId : msg.messageTypeId;
                if (messageTypeId === actionConstants.messageTypeEnum.Warning) {
                    toast.warning(messageContent);
                }
              
                else if (messageTypeId === actionConstants.messageTypeEnum.Error) {
                    toast.error(messageContent);
                }
                else if (messageTypeId === actionConstants.messageTypeEnum.RequestOutOfDate) {
                    document.getElementById('old-version-warning-modal').style.display = "block";
                }
            }
        }
    }
    response.data = response.data || [];

    return response;
}, 
function (error) {    
    console.log(error);

    // A request can opt out of the generic error toast (best-effort fetches that render
    // their own inline failure state) via config.suppressToast or the X-Suppress-Toast header.
    const cfg = error.config || {};
    const suppressToast = cfg.suppressToast === true || cfg.headers?.['X-Suppress-Toast'] === 'true';

    // No response = transport-level failure (offline / timeout / CORS / cancelled request).
    // Guard so we never read .status off an undefined response (which threw a raw
    // "Cannot read properties of undefined (reading 'status')" into the UI), and give the
    // user an actionable message instead of the generic catch-all.
    const status = error.response?.status;

    if (status === 401) {
        window.parent.location.href = "/authentication/logout";
    }
    else if (status === 403) {
        toast.error('You are not allowed to perform this action. Please contact the system administrator.');
        if(!window.parent.location.href.toLowerCase().includes(Constants.Route.DatabaseOverview)) {
            setTimeout(function () {
                window.parent.location.href = "/HomePage"; 
            }, 2000);
        }
    }
    else if (!error.response) {
        // Transport-level failure: no HTTP response ever came back.
        if (!suppressToast) {
            toast.error('Could not reach the server. Check your connection and try again.');
        }
    }
    else if (!suppressToast)
    {
        toast.error('An unexpected error has occurred. Please contact the system administrator.');
    }
    
    return Promise.reject(error);
});

export default errorResponseHandler;